import { initNav } from './parts/nav'
import { initSliders } from './parts/slideshow'
import { initLightbox } from './parts/lightbox'
import { setGalleryLinks } from './parts/project-gallery'
import { makeDropdown, safDropdown } from './parts/dropdowns'
import { Modal } from './parts/modal'
import './parts/filters-custom'

init()

function init() {
    initNav()
    initDropdowns()
    initModals()
    initSliders()
    initLightbox()
    setGalleryLinks()
}

function initDropdowns() {
    let dropdowns = document.querySelectorAll('.spdrop')
    dropdowns.forEach((dropdown) => {
        if (dropdown instanceof HTMLElement) {
            makeDropdown(dropdown)
        }
    })

    let safEls = document.querySelectorAll(
        '.sf-field-taxonomy-project-types, .sf-field-taxonomy-spaces'
    )
    let insertAfter = document.querySelector('.sf-field-taxonomy-sectors')

    if (safEls.length && insertAfter instanceof HTMLElement) {
        safDropdown(Array.from(safEls) as HTMLElement[], insertAfter)
    }
}

function initModals() {
    let modal: Modal
    let modalContainer = document.querySelector('.sp-modal')
    if (modalContainer instanceof HTMLElement) {
        modal = new Modal(modalContainer)
    }

    let triggers = [...document.querySelectorAll('.sp-modal__open')]
    let triggerEls: HTMLElement[] = []
    triggers.forEach((tr) => {
        if (tr instanceof HTMLElement) triggerEls.push(tr)
    })

    if (triggers.length > 0) {
        modal.addTriggers(triggerEls)
    }
}
